import { Box, Button, Input, InputGroup, InputLeftElement, Link, Text, useDisclosure } from "@chakra-ui/react"
import { ReactComponent as Search } from '../../svg/Search.svg';
import { Link as redirectLink } from 'react-router-dom'
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { searchFinal, searchQuery, setAutocompleteVisibility } from "../../redux/actions/actions";
import AdvancedSearchModal from "./AdvancedSearchModal";

export default function SearchComponent({ notShowAdvSearch }) {
    const { name, link, bgColor, hoverColor, parameters } = useSelector(state => state.headerState)
    const { displayList, autocompleteVisible } = useSelector(state => state.searchState)
    const [searchText, setSearchText] = useState("")
    const dispatch = useDispatch()
    const { isOpen, onOpen, onClose } = useDisclosure()


    const changeHandler = (e) => {
        setSearchText(e.target.value)
        dispatch(searchFinal(""))
    }

    const itemSelector = (id) => {
        setSearchText(displayList[id])
        dispatch(searchQuery(displayList[id]))
        dispatch(searchFinal(displayList[id]))
    }

    const keyPressHandler = (e) => {
        if (e.key === "Enter") {
            dispatch(searchFinal(searchText))
            dispatch(setAutocompleteVisibility(false))
        }
    }

    useEffect(() => {
        dispatch(searchQuery(searchText))
        // eslint-disable-next-line
    }, [searchText])

    return (
        <Box
            d={['none', 'none', 'none', 'flex']}
            alignItems='center'
            justifyContent='flex-end'
            flex='1'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >
            <Box width={['50%', '50%', '35%', '28%']} position='relative'>
                <InputGroup
                    width='100%'
                    d='flex'
                    justifyContent='center'
                >
                    <InputLeftElement
                        pointerEvents='none'
                        children={<Search color="#999999" width='16px' height='16px' />}
                    />
                    <Input
                        type='text'
                        placeholder='Search'
                        mr='1rem'
                        fontSize={['13px', '14px', '16px']}
                        fontWeight='600'
                        bg='#f0f0f0'
                        borderRadius='10px'
                        value={searchText}
                        color='#999999'
                        onChange={changeHandler}
                        onClick={(e) => e.stopPropagation()}
                        onKeyPress={keyPressHandler}
                        onFocus={(e) => {
                            e.stopPropagation()
                            dispatch(setAutocompleteVisibility(true))
                        }}
                    />
                </InputGroup>
                <Box
                    position='absolute'
                    display={autocompleteVisible ? 'flex' : 'none'}
                    justifyContent='flex-start'
                    flexDirection='column'
                    top='100%'
                    left='0'
                    bg='white'
                    width='95%'
                    fontSize={['10px', '10px', '10px', '10px', '12px']}
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    padding='1rem 0'
                    borderBottomRadius='10px'
                    zIndex='20'
                >
                    {
                        displayList.length > 0 ? displayList.map((item, id) => <Text
                            key={id}
                            padding='3px 1rem'
                            onClick={() => itemSelector(id)}
                            cursor='pointer'
                            _hover={{ backgroundColor: '#efefef' }}
                        >
                            {item}
                        </Text>)
                            :
                            <Text
                                pointerEvents='none'
                                padding='3px 1rem'
                            >
                                No matching term!
                            </Text>
                    }
                </Box>
            </Box>
            {!notShowAdvSearch &&    <Button
                bgColor={bgColor}
                color='white'
                variant='outline'
                p={['0.5rem', '0.75rem', '1rem']}
                fontWeight='700'
                fontSize={['13px', '14px', '16px']}
                style={{ fontFamily: 'Mulish, sans-serif' }}
                borderRadius='lg'
                _hover={{ bg: hoverColor }}
                mr = '1rem'
                onClick = {onOpen}
            >
                Advanced Search
            </Button>}
         

            <Link as={redirectLink} to={link} style={{ textDecoration: 'none' }}>
                <Button
                    bgColor={bgColor}
                    color='white'
                    variant='outline'
                    p={['0.5rem', '0.75rem', '1rem']}
                    fontWeight='700'
                    fontSize={['13px', '14px', '16px']}
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    borderRadius='lg'
                    _hover={{ bg: hoverColor }}
                >
                    + Add {name}
                </Button>
            </Link>
            <AdvancedSearchModal color = {bgColor} hoverColor = {hoverColor} isOpen = {isOpen} onClose = {onClose} title = {`Advanced Search - ${name}`} parameters = {parameters}/>
        </Box>
    )
}

SearchComponent.defaultProps = {
    notShowAdvSearch: false
}